import OriginalGatsbyLink from "gatsby-link";
import * as React from "react";
import styled from "styled-components";

import { colors } from "../../helpers";

const GatsbyLink = styled(OriginalGatsbyLink)`
    color: ${colors.link.default};
    text-decoration: underline;

    :hover {
        color: ${colors.link.hover};
    }
`;

export default GatsbyLink;
